import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useAuth from '../../common/hooks/user/useAuth';

const ProtectedRoute = () => {
  const { authenticated } = useAuth();
  const location = useLocation();

  if (!authenticated) {
    if (!location.pathname.startsWith('/auth')) {
      return <Navigate to="/auth" />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
